import React, { Component } from "react";
import packBase from "../data/packages.json";
import { connect } from "react-redux";

class Package extends Component {
	render() {
		const { index, language, langBase } = this.props;
		const services =
			packBase[index].services[language] &&
			packBase[index].services[language].map((elem, i) => {
				return (
					<li key={"idx_" + i} className="punkt">
						<i className="material-icons pointer" style={{ color: packBase[index].color }}>
							chevron_right
						</i>
						{elem}
					</li>
				);
			});
		return (
			<div className="card sticky-action">
				<div
					className="card-image waves-effect waves-block waves-light"
					style={{
						backgroundImage: `linear-gradient(
            to top,
            rgba(0, 0, 0, 0.6),
            rgba(0, 0, 0, 0) 50%
          ),url(${packBase[index].image})`,
						borderBottom: `2px solid ${packBase[index].color}`
					}}>
					<div className="offer">
						<div className="offer-subtitle">{index !== 4 ? langBase.pakiet : langBase.retush}</div>
						<div className="offer-title" style={{ color: packBase[index].color }}>
							{index !== 4 ? packBase[index].name : langBase.retush_name}
						</div>
					</div>
				</div>
				<div className="card-content">
					<span className="card-title activator ">
						<i className="material-icons right">more_vert</i>
					</span>
					<ul className="offer-list">{services && services}</ul>
				</div>
				<div className="card-action" style={{ color: packBase[index].color }}>
					{index !== 4 ? packBase[index].price : langBase.no_price} <span>{index !== 4 ? "zł" : ""}</span>
					{index !== 4 ? (
						""
					) : (
						<span className="no-price-desc" style={{ color: "#000000" }}>
							{langBase.no_price_desc}
						</span>
					)}
				</div>
				<div className="card-reveal">
					<span className="card-title grey-text text-darken-4" style={{ borderColor: packBase[index].color }}>
						{index !== 4 ? langBase.pakiet : langBase.retush}{" "}
						<span className="card-title activator">
							{index !== 4 ? packBase[index].name : langBase.retush_name}
						</span>
						<i className="material-icons right">close</i>
					</span>
					<p>{packBase[index].desc[language] && packBase[index].desc[language]}</p>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	language: state.language,
	langBase: state.langBase
});

export default connect(mapStateToProps)(Package);
